export function formatPhoneNumber(number) {
	if (number) {
		let cleanednumber = number;
		if (number.startsWith("00")) {
			cleanednumber = number.replace("00", "+");
		} else {
			if (!number.startsWith("+")) {
				cleanednumber = "+" + number;
			}
		}
		return cleanednumber;
	} else {
		return "NA";
	}
};
